// Key prefix that preceeds every data entry in the local storage.
export const LOCAL_STORAGE_PREFIX = 'hflw_';


// Keys that store array of objects structures about persons, companies and agencies registered byt the user.
export const CUSTOMER_PERSON_LIST = LOCAL_STORAGE_PREFIX + 'person_list';
export const CUSTOMER_COMPANY_LIST = LOCAL_STORAGE_PREFIX + 'company_list';
export const CUSTOMER_AGENCY_LIST = LOCAL_STORAGE_PREFIX + 'agency_list';

// Keys that store the timestamp at which the data above was last updated.
export const CUSTOMER_PERSON_SERIAL = LOCAL_STORAGE_PREFIX + 'person_serial';
export const CUSTOMER_COMPANY_SERIAL = LOCAL_STORAGE_PREFIX + 'company_serial';
export const CUSTOMER_AGENCY_SERIAL = LOCAL_STORAGE_PREFIX + 'agency_serial';


// Key that store the booking status code list
export const BOOKING_STATUS_CODES = LOCAL_STORAGE_PREFIX + 'booking_status_codes';

// Key that stores the user web settings
export const USER_WEB_SETTINGS = LOCAL_STORAGE_PREFIX + 'user_web_settings';

// Flags that will tell if some features are enabled or not.
export const HOUSEKEEPING_ENABLED = LOCAL_STORAGE_PREFIX + 'housekeeping_enabled';
export const CASHFLOW_ENABLED = LOCAL_STORAGE_PREFIX + 'cashflow_enabled';


// Timestamp that is used for some calculations regarding the user's session.
export const LAST_RELOAD = LOCAL_STORAGE_PREFIX + 'last_reload';


// Reservation list that will be stored in the local storage
export const RESERVATION_LIST = LOCAL_STORAGE_PREFIX + 'reservation_list';


// Timestamp key that stores the last update from the reservations
export const GLOBAL_RESERVATION_LAST_UPDATE = 'hud_booking_data_serial';
export const LOCAL_RESERVATION_LAST_UPDATE = LOCAL_STORAGE_PREFIX + 'local-reservations_last_update';


// Timestamp keys regarding the hotel last updates
export const GLOBAL_HOTEL_LAST_UPDATE = LOCAL_STORAGE_PREFIX + 'global-hotel_last_update';
export const LOCAL_HOTEL_LAST_UPDATE = LOCAL_STORAGE_PREFIX + 'local-hotel_last_update';


// Timestamp key that stores the last update from the housekeeping
export const GLOBAL_HOUSEKEEPING_LAST_UPDATE = 'hud_housekeeping_data_serial';
export const LOCAL_HOUSEKEEPING_LAST_UPDATE = LOCAL_STORAGE_PREFIX + 'local-housekeeping_last_update';


// Calendar multi-tab optimization keys
export const CALENDAR_IS_FETCHING = LOCAL_STORAGE_PREFIX + 'shared-calendar_is_fetching';


// Chunks storage
export const BOOKINGS_CHUNKS_LIST = LOCAL_STORAGE_PREFIX + 'bookings_chunk_list';


// Totalizers namespace
export const CALENDAR_TOTALIZERS = LOCAL_STORAGE_PREFIX + 'calendar_totalizers';